import React from "react";
import { isMobile } from "react-device-detect";
import { ReactComponent as plano_imagem } from '../../assets/plano_imagem.svg'
import { ReactComponent as dinamometro_imagem } from  '../../assets/dinamometro_imagem.svg'
import { ReactComponent as palmar_imagem } from  '../../assets/palmar_imagem.svg'
import { ReactComponent as CheckCircle } from  '../../assets/check_circle.svg'
import { ReactComponent as HistoryDefaultIcon } from '../../assets/history-default.svg'
import { formatarMoeda } from "../../../src/lib/utils";

type themeType = "gray" | "green";
type ImageKey = 'dinamometro_tracao' | 'assinatura' | 'dinamometro_palmar' | "none"
type IconComponent = React.FC<React.SVGProps<SVGSVGElement>>

interface Props {
  title: string;
  valor?: string;
  unidades?: number;
  theme: themeType
  parcelas?: string;
  imagem: ImageKey;
  total?: string;
  pago?: boolean;
  autorizado?: boolean;
}


const Product: React.FC<Props> = ({ title, valor, parcelas, unidades, theme, imagem, total, pago, autorizado }) => {

  const image_model: Record<ImageKey, IconComponent> = {
    'assinatura': plano_imagem,
    'dinamometro_tracao': dinamometro_imagem,
    'dinamometro_palmar': palmar_imagem,
    'none': () => null
  }

  const IconComponent = image_model[imagem];


  return (
    <div
      className={`
        flex
        flex-row
        px-[1rem]
        py-[1rem]
        ${isMobile && 'mt-[1.6rem]'} 
        ${theme === "gray" ? 'bg-gray-light' : 'bg-green-light border   border-green-medium'} 
        w-[100%]
        justify-between
        items-center
        rounded-[0.5rem]
        ${!isMobile && 'border border-gray-medium border-[2px]'} 
      `}
    >
      <div className="">
        <p className="text-[0.9rem] font-[600] text-gray-dark ">{title}</p>
        
        {!valor && ( pago || autorizado ?
        <div className="flex flex-row items-center gap-x-[0.3rem] mt-[0.2rem]">
          <CheckCircle className='w-[1rem] h-[1rem]' />
          <p className="text-[0.9rem] font-[600] text-gray-dark ">{pago ? "Pago" : "Autorizado"}</p>
        </div>
        :
        <div className="flex flex-row items-center gap-x-[0.3rem] mt-[0.2rem]">
          <HistoryDefaultIcon className='w-[1rem] h-[1rem]' />
          <p className="text-[0.9rem] font-[600] text-gray-font">Aguardando pagamento</p>
        </div>
        )
        }
        {valor &&
          <p className="text-[0.8rem] mt-[0.2rem]">
            {parcelas && imagem !== "assinatura" && parcelas + "x de "}
            <strong className="font-[600] text-[0.9rem]">
              R$ {formatarMoeda(unidades ? (Number(valor) * unidades) / Number(parcelas) : (Number(valor) / Number(parcelas)) )}
            </strong>
          </p>
        }
        {total &&
          <strong className="text-[0.7rem]  mt-[0.2rem]">Total R$ {formatarMoeda(unidades ? (Number(total) * unidades) : total)}{imagem === "assinatura" ? "/mês" : ""} </strong>
        }
        {unidades &&
          <p className="text-[0.7rem]  mt-[0.2rem]">{unidades} unidade</p>
        }
      </div>
      <div className="">
        {imagem !== "none" && (
          <IconComponent
            className="w-[4rem] h-[4rem]"
          />
        )}
      </div>
    </div>
  );
};

export default Product;
